export const DH = {
    SEATING_STAGE: 'seating-stage',
};
//# sourceMappingURL=hooks.js.map